/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VinaJobInfo
 */
export interface VinaJobInfo {
    /**
     * 
     * @type {number}
     * @memberof VinaJobInfo
     */
    status: number;
    /**
     * 
     * @type {boolean}
     * @memberof VinaJobInfo
     */
    allowed: boolean;
}

/**
 * Check if a given object implements the VinaJobInfo interface.
 */
export function instanceOfVinaJobInfo(value: object): value is VinaJobInfo {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('allowed' in value) || value['allowed'] === undefined) return false;
    return true;
}

export function VinaJobInfoFromJSON(json: any): VinaJobInfo {
    return VinaJobInfoFromJSONTyped(json, false);
}

export function VinaJobInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VinaJobInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'allowed': json['allowed'],
    };
}

export function VinaJobInfoToJSON(json: any): VinaJobInfo {
    return VinaJobInfoToJSONTyped(json, false);
}

export function VinaJobInfoToJSONTyped(value?: VinaJobInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'allowed': value['allowed'],
    };
}

